import { useNavigate } from "react-router-dom";

function FooterB() {
  const navigate = useNavigate();

  const handleClick = (event, path) => {
    event.preventDefault();
    navigate(path);
  };
  return (
    <footer id="Footer" className="clearfix" style={{ padding: "20px 0" }}>
      <div className="widgets_wrapper" style={{ padding: "30px 0" }}>
        <div className="container">
          <div className="column one-third">
            <aside className="widget widget_text">
              <div className="textwidget">
                <div className="image_frame image_item no_link scale-with-grid alignnone no_border">
                  <div className="image_wrapper">
                    <img
                      className="scale-with-grid"
                      src="content/architect2/images/home_architect2_footer_logo.jpg"
                      width={225}
                      height={25}
                    />
                  </div>
                </div>
                <hr className="no_line" style={{ margin: "0 auto 15px" }} />
                <p style={{ marginRight: "5%" }}>
                  App Makelaar, uw betrouwbare partner in IT-oplossingen,
                  speciaal ontworpen voor het midden- en kleinbedrijf. Wij
                  bieden geavanceerde, op maat gemaakte technologieën om uw
                  bedrijfsprocessen te optimaliseren en te stroomlijnen. Voor
                  vragen, ondersteuning of meer informatie, neem gerust contact
                  met ons op. Samen bouwen we aan de toekomst van uw
                  onderneming.
                </p>
                <a href="/info" onClick={(e) => handleClick(e, "/info")}>
                  Lees meer ...
                </a>
              </div>
            </aside>
          </div>
          <div className="column one-third">
            <aside className="widget widget_text">
              <div className="textwidget">
                <ul style={{ lineHeight: "20px" }}>{/* List items here */}</ul>
              </div>
            </aside>
          </div>
          <div className="column one-third">
            <aside className="widget widget_text">
              <h4>Contact informatie</h4>
              <div className="textwidget">
                {/* Contact information here */}
                <p style={{ fontSize: "14px", lineHeight: "20px" }}>
                  {/* Icons and links here */}
                </p>
                <p>
                  Neem contact met ons op:
                  <br />
                  E-mail ons:{" "}
                  <a href="mailto:info@appmakelaar.nl">info@appmakelaar.nl</a>
                </p>
              </div>
            </aside>
          </div>
        </div>
      </div>
      <div className="footer_copy">
        <div className="container">
          <div className="column one">{/* Copyright information here */}</div>
        </div>
      </div>
    </footer>
  );
}
export default FooterB;
